export default {
  storeNamespace: 'reference',
  authFeature: 'reference',
  listRouteName: "AgencyRentingsList",
  detailRouteName: "ReferenceDetail",
  hideActionNewButton: true,
  hideActionEditButton: true,
  hideActionPdfButton: true,
  hideActionDeleteButton: true,
  csvExportFilenamePrefix: 'Locations agences',
  titleField: 'internal_code',
  showExtendedFilters: true,
  fields: [
    {
      name: 'agency_number',
      label: "Agence courante",
      type: 'chosen',
      inList: true,
      extendedFilter: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].agency ? item.reference_logs[0].agency.number : null
    },
    {
      name: 'business_number',
      label: "Affaire courante",
      type: 'text',
      inList: true,
      extendedFilter: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].business ? item.reference_logs[0].business.number : null
    },
    {
      name: 'business_name',
      label: "Désignation affaire",
      type: 'text',
      inList: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].business ? item.reference_logs[0].business.name : null
    },
    {
      name: 'internal_code',
      label: "Code interne",
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'product',
      label: "Produit",
      inList: true,
      sortable: true,
      inCsvExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'group_slug',
      label: "Service",
      type: 'select',
      inList: true,
      sortable: true,
      extendedFilter: true,
    },
    {
      name: 'group_slug',
      label: "Service",
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$store.getters['renting_preparation/getGroup'](value).text : null
    },
    {
      name: 'last_location_date',
      label: "Date de début",
      type: 'date',
      inList: true,
      sortable: true,
      extendedFilter: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'duration',
      label: "Durée en jours",
      inList: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].start_date ? context.$moment().diff(context.$moment(item.reference_logs[0].start_date), 'days')+1 : null
    },
    {
      name: 'renting_total_price',
      label: "Prix total",
      type: 'number',
      step: 0.01,
      inForm: false,
      required: false,
      inList: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].renting_total_price ? parseFloat(item.reference_logs[0].renting_total_price).toFixed(2) + '€' : 0 + " €"
    },
    {
      name: 'renting_total_price',
      label: "Prix total",
      type: 'number',
      step: 0.01,
      inForm: false,
      required: false,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].renting_total_price ? parseFloat(item.reference_logs[0].renting_total_price).toFixed(2) : 0
    },
    {
      name: 'user',
      label: "Utilisateur",
      type: 'text',
      inList: true,
      sortable: true,
      extendedFilter: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.reference_logs && item.reference_logs[0] && item.reference_logs[0].employee && item.reference_logs[0].employee.fullname ? item.reference_logs[0].employee.fullname : ''
    },
    {
      name: 'next_espected_maintenance_date',
      label: "Prochaine maintenance",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/AgencyRentings/config.js